import React from "react";
const MdaeDrawerListItemMenuTemplate: React.FC<any> = (props) => {
  return (
    <div
      style={{
        paddingLeft: "unset",
        marginLeft:
          props.mdaeMenuPanelItemSubmenuItem.menuSectionTitle ||
          props.mdaeMenuPanelItemSubmenuItem.isMainMenuListItem
            ? ""
            : "20px",
      }}
    >
      {(!props.mdaeMenuPanelItemSubmenuItem.menuSectionTitle ||
        props.mdaeMenuPanelItemSubmenuItem.isMainMenuListItem) && (
        <div style={{ width: "100%", height: "100%" }}>
          {props.mdaeNewNavigationBarConfig.hasItemAnySubmenu(
            props.mdaeMenuPanelItemSubmenuItem
          ) &&
            props.isMdaeNavigationBarExpanded && (
              <div
                style={{
                  color: "rgba(0, 0, 0, 0.87)",
                  textDecoration: "unset",
                  height: "100%",
                  width: "100%",
                  fontWeight: 500,
                  fontSize: "12px",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    style={{
                      color: props.auditsSectionMenuItemListItem.selected
                        ? "white"
                        : "rgba(0, 0, 0, 0.87)",
                    }}
                  >
                    {props.mdaeMenuPanelItemSubmenuItem.title + " "}
                    {props.mdaeMenuPanelItemSubmenuItem?.isNewMenu === true && (
                      <sup>
                        <span className="dx-new-menu-ind">New</span>
                      </sup>
                    )}
                  </div>
                  <div>
                    <i
                      className="dx-icon-chevronright"
                      style={{
                        fontSize: "18px",
                        fontWeight: 500,
                        color: props.auditsSectionMenuItemListItem.selected
                          ? "white"
                          : "rgba(0, 0, 0, 0.87)",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
            )}

          {!(
            props.mdaeMenuPanelItemSubmenuItem.items &&
            props.mdaeMenuPanelItemSubmenuItem.items.length
          ) && (
            <a
              href={props.mdaeMenuPanelItemSubmenuItem.menuUrl}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                props.changePageLocation(
                  props.mdaeMenuPanelItemSubmenuItem.menuUrl,
                  props.mdaeMenuPanelItemSubmenuItem.isOpenInNewTab,
                  props.mdaeMenuPanelItemSubmenuItem.mdaeMenuClickHandler,
                  props.mdaeMenuPanelItemSubmenuItem.isReactMenu
                );
              }}
              style={{
                color: "rgba(0, 0, 0, 0.87)",
                textDecoration: "unset",
                height: "100%",
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              {props.mdaeMenuPanelItemSubmenuItem.title + " "}
              {props.mdaeMenuPanelItemSubmenuItem?.isNewMenu === true && (
                <sup>
                  <span className="dx-new-menu-ind">New</span>
                </sup>
              )}
            </a>
          )}
        </div>
      )}

      {!(
        !props.mdaeMenuPanelItemSubmenuItem.menuSectionTitle ||
        props.mdaeMenuPanelItemSubmenuItem.isMainMenuListItem
      ) && (
        <div className="menu-section-title-item">
          {props.mdaeMenuPanelItemSubmenuItem.menuSectionTitle}
        </div>
      )}

      {props.mdaeNewNavigationBarConfig.hasItemAnySubmenu(
        props.auditsSectionMenuItemListItem
      ) &&
        !props.isMdaeNavigationBarExpanded && (
          <div
            className={
              "menu-icon " +
              props.auditsSectionMenuItemListItem.iconClassName +
              (props.auditsSectionMenuItemListItem.selected ? " selected " : "")
            }
            title={props.auditsSectionMenuItemListItem.title}
          ></div>
        )}
    </div>
  );
};
export default MdaeDrawerListItemMenuTemplate;
